export const scopes = [
  // Test endpoint
  'wealth.integrations.management.v1.Echo:read offline_access openid profile email',
  'wealth.legacy.aw_api.v1.AggregateAnalysis:read',
  'wealth.legacy.aw_api.v1.Proposals:read',
  'wealth.legacy.aw_api.v1.Proposals:write',
  'wealth.legacy.aw_api.v1.ProposalSnapshots:read',
  'wealth.legacy.aw_api.v1.ProposalSnapshots:write',
  'wealth.legacy.aw_api.v1.Security:read',
  'wealth.legacy.aw_bff.v1.EventLogger:write',
  'wealth.legacy.aw_server.v1.CloakClientData:read',
  'wealth.legacy.aw_server.v1.DeepDive:read',
  'wealth.legacy.aw_server.v1.FaAccounts:read',
  'wealth.legacy.aw_server.v1.Workflow:read',
  'wealth.legacy.aw_server.v1.Workflow:write',
  'wealth.legacy.aw_server.v1.WorkflowDates:read',
  'wealth.legacy.aw_userpref.v1.UapTou:read',
  'wealth.legacy.aw_userpref.v1.UapTou:write',
  'wealth.legacy.aw_userpref.v1.UserAttributes:read',
  'wealth.legacy.aw_userpref.v1.UserAttributes:write',
  'wealth.legacy.apb_server.v1.ForeignExchangeRate:read',
  'wealth.legacy.apb_server.v1.ProposalAnalysis:write',
  'wealth.legacy.apb_server.v1.Securities:read',
  'wealth.legacy.aw_api.v1.Events:write',
  'wealth.legacy.aw_api.v1.PortfolioAnalysis:read',
  'wealth.legacy.aw_api.v1.ProposalEntries:read',
  'wealth.legacy.aw_bff.v1.ApplicationMode:read',
  'wealth.legacy.aw_bff.v1.ApplicationMode:write',
  'wealth.legacy.aw_bff.v1.ComplianceRule:read',
  'wealth.legacy.aw_bff.v1.Dates:read',
  'wealth.legacy.aw_bff.v1.DynamicFormStepper:read',
  'wealth.legacy.aw_bff.v1.Packages:read',
  'wealth.legacy.aw_bff.v1.PdfExport:read',
  'wealth.legacy.aw_bff.v1.PdfExport:write',
  'wealth.legacy.aw_bff.v1.UiConfig:read',
  'wealth.legacy.aw_bff.v1.User:read',
  'wealth.legacy.aw_bff.v1.Version:read',
  'wealth.legacy.aw_bff.v1.ViewAs:read',
  'wealth.legacy.aw_portfolio.v1.Aggregates:read',
  'wealth.legacy.aw_portfolio.v1.Aggregates:write',
  'wealth.legacy.aw_portfolio.v1.Portfolio:read',
  'wealth.legacy.aw_portfolio.v1.Portfolio:write',
  'wealth.legacy.aw_portfolio.v1.SleeveInfoBulkGet:read',
  'wealth.legacy.aw_server.v1.Analysis:read',
  'wealth.legacy.aw_server.v2.Analysis:read',
  'wealth.legacy.aw_server.v1.PortfolioSearch:read',
  'wealth.legacy.aw_userpref.v1.ActionsFilters:read',
  'wealth.legacy.aw_userpref.v1.ActionsFilters:write',
  'wealth.legacy.aw_userpref.v1.BookSync:read',
  'wealth.legacy.aw_userpref.v1.BookSync:write',
  'wealth.legacy.aw_userpref.v1.DeepDiveProposalTabs:read',
  'wealth.legacy.aw_userpref.v1.DeepDiveProposalTabs:write',
  'wealth.legacy.aw_userpref.v1.DomainFilters:read',
  'wealth.legacy.aw_userpref.v1.DomainFilters:write',
  'wealth.legacy.aw_userpref.v1.Exposures:read',
  'wealth.legacy.aw_userpref.v1.Exposures:write',
  'wealth.legacy.aw_userpref.v1.Filters:read',
  'wealth.legacy.aw_userpref.v1.Filters:write',
  'wealth.legacy.aw_userpref.v1.PrdFilters:read',
  'wealth.legacy.aw_userpref.v1.PrdFilters:write',
  'wealth.legacy.aw_userpref.v1.ProposalPreferences:read',
  'wealth.legacy.aw_userpref.v1.ProposalPreferences:write',
  'wealth.legacy.aw_userpref.v1.RecentlySearchedEntities:read',
  'wealth.legacy.aw_userpref.v1.RecentlySearchedEntities:write',
  'wealth.legacy.aw_userpref.v1.ReportOverrides:read',
  'wealth.legacy.aw_userpref.v1.ReportOverrides:write',
  'wealth.legacy.aw_userpref.v1.SelectedPages:read',
  'wealth.legacy.aw_userpref.v1.SelectedPages:write',
  'wealth.legacy.aw_userpref.v1.TermsOfUseAcknowledgement:read',
  'wealth.legacy.aw_userpref.v1.TermsOfUseAcknowledgement:write',
  'wealth.integrations.partners.v1.Platform:read',
  'wealth.integrations.partners.v1.Platform:write',
  'wealth.integrations.partners.v1.ExternalAccountInfo:read',
  'wealth.integrations.partners.v2.Account:read',
  'wealth.integrations.partners.models.v1.ExternalModelReference:read',
  'wealth.integrations.outbound.v1.OutboundOperation:read',
  'wealth.integrations.outbound.v1.OutboundOperation:write',
  'wealth.portfolio_management.models.v1.Model:read',
  'wealth.portfolio_management.models.v1.Model:write',
  'wealth.portfolio_management.portfolios.v1.Account:read',
  'wealth.portfolio_management.portfolios.v1.Account:write',
  'wealth.portfolio_management.portfolios.v1.Aggregate:read',
  'wealth.portfolio_management.portfolios.v1.Aggregate:write',
  'wealth.shared_service.localization.v1.Localization:read',
  'wealth.shared_service.users.v1.User:read',
  'wealth.shared_service.users.v1.UserEntitlement:read',
  'wealth.shared_service.users.v1.UserEntitlement:write',
];
